module.exports = __webpack_public_path__ + "img/adobe-commerce-vs-magento.0a643d1f.jpeg";